import { get, orderBy } from 'lodash'
import { createSelector } from 'reselect'
import { ACTIVITY_STATES } from 'constants/enums'

const participants = (participants, options) => ({ participants, options })

const determineOrder = (state = {}, { isAssessmentPositive = false } = {}) => {
  switch (state.value) {
    case ACTIVITY_STATES.assessment.id:
      return !isAssessmentPositive ? 10 : 9
    case ACTIVITY_STATES.in_progress.id:
      return 8
    case ACTIVITY_STATES.award_leader_singoff.id:
      return 7
    default:
      return 1
  }
}

const handleMapAndFilterParticipant = (participants = [], options) => {
  let allParticipantSections = []

  participants.forEach(participant => {

    const activityMap = get(participant, 'participant.assessorActivities.assessorActivityMap')

    const participantEntity = get(participant, 'participant')

    // map all section types
    const participantActivities = get(
      participant,
      'activities',
      []
    ).filter(a => {
      const pid = get(a, 'assessor.person.id')

      const assessorActivityMap = activityMap[pid]

      const actCatReg = assessorActivityMap && assessorActivityMap.filter(ar => get(ar, 'activityCategoryId') === get(a, 'activityCategory.id'))[0]

      return get(a, 'activityState.value') !== ACTIVITY_STATES.waiting_for_approval.id && get(actCatReg, 'isRegConfirmed')
    }).map(activity => ({
      ...activity,
      state: activity.activityState,
      uiOrder: determineOrder(activity.activityState, {
        isAssessmentPositive: get(activity, 'isAssessmentPositive')
      }),
      participant: participantEntity
    }))

    const participantAJs = get(
      participant,
      'adventurousJourneys',
      []
    ).filter(a => get(a, 'state.value') !== ACTIVITY_STATES.waiting_for_approval.id).map(aj => ({
      ...aj,
      state: aj.state,
      uiOrder: determineOrder(aj.state, {
        isAssessmentPositive: get(aj, 'isAssessmentPositive')
      }),
      participant: participantEntity
    }))

    let participantRp = {
      state: get(participant, 'residentialProject.state'),
      uiOrder: determineOrder(
        get(participant, 'residentialProject.state', {}),
        {
          isAssessmentPositive: get(
            participant,
            'residentialProject.isAssessmentPositive'
          )
        }
      ),
      participant: participantEntity
    }
    if(get(participant, 'residentialProject.state.value') !== ACTIVITY_STATES.waiting_for_approval.id){
      participantRp = {
        ... participantRp,
        ...get(participant, 'residentialProject', {}),
      }
    }


    // flatten all sections into a single array
    allParticipantSections = allParticipantSections
      .concat(participantActivities)
      .concat(participantAJs)
      .concat(participantRp)
  })

  return allParticipantSections.filter(section => {
    if (get(section, 'assessorEmail')) {
      return section.assessorEmail === get(options, 'assessorEmail')
    } else if (get(section, 'ajEvent.assessorEmail')) {
      return section.ajEvent.assessorEmail === get(options, 'assessorEmail')
    }
  })
}

const mapForDropdown = ({ participants, options }) => {
  const mappedActivities = handleMapAndFilterParticipant(participants, options)

  return orderBy(mappedActivities, ['uiOrder'], ['desc'])
}

export default createSelector(participants, mapForDropdown)
